import { render, staticRenderFns } from "./orders-list.vue?vue&type=template&id=0b5f3565&"
import script from "./orders-list.vue?vue&type=script&lang=js&"
export * from "./orders-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports